/* eslint-disable react/jsx-pascal-case */
import { Col, DatePicker, ConfigProvider, Form, Input, Row, Button, Select } from "antd";
import dayjs from 'dayjs';
import React, { useEffect, useState, useRef } from "react";
// import Label_language from '../../language'
import UploadImg from '../../utility/UploadImg'
import { useNewsType } from "../controller/NewsTypeController";
import { useNewsWeightType } from "../../news_weight_type/controller/NewsWeightTypeController";
import JoditEditor from "jodit-react";
const { ConfigContext } = ConfigProvider

const NewsForm = (
    {
        propsForm = null,
        formReloadCount = 0,
        onFormFinish = () => { },
    }
) => {
    const [form] = Form.useForm();
    const [files, setFiles] = useState([])
    const [content, setContent] = useState("")
    const editor = useRef(null);
    const config = {
        // readonly: false, // all options from https://xdsoft.net/jodit/doc/
        // uploader: {
        //     insertImageAsBase64URI: true,
        //     // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        // },
        // language: 'zh_tw'
        allowResizeTags: false,
        imageDefaultWidth: "100%",
        language: 'zh_tw',
        i18n: {
            zh_tw: {
                'Default': "預設",
                'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
                    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
                Anchor: 'Anchor',
                Margins: '外邊距（Margins）',
                top: 'top',
                right: 'right',
                bottom: 'bottom',
                left: 'left',
                Classes: 'Classes',
                Src: 'Src',
                Title: 'Title',
                Link: 'Link',
                file: 'file',
                'Image properties': '圖片屬性',
                'Your code is similar to HTML. Keep as HTML?':
                    '你黏貼的文本是一段html代碼，是否保留源格式',
                'Paste as HTML': 'html黏貼',
                'Insert as Text': '把html代碼視為普通文本',
                'Error on load list': '加載list錯誤',
                Break: 'Pause',
                'No follow': 'No follow',
                'URL': 'URL',
                Crop: 'Crop',
                Default: '默認',
                Circle: '圓圈',
                Dot: '點',
                Quadrate: '方形',
                Find: '搜尋',
                'Insert className': '插入標籤名稱',
                'Press Alt for custom resizing': '按Alt自定義調整大小',
                'Find Next': '找下一個',
                'Find Previous': '找上一個',
                'replace': '替代',
                'Line height': '行高'
            }
        },
        uploader: {
            insertImageAsBase64URI: true,
            imagesExtensions: [
                "jpg",
                "png",
                "jpeg",
                "gif",
                "svg",
                "webp",
            ],
        },
    };
    const {
        newsTypeOption,
        getNewsTypeOption,
        postNewsTypeData,
    } = useNewsType({
        onFinish: () => { },
        onBefore: () => { }
    })
    const {
        getNewsWeightTypeOption,
        newsWeightTypeOption
    } = useNewsWeightType({
        onFinish: () => { },
        onBefore: () => { }
    })
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }
    const onChangeFileValue = (values) => {
        let file = values?.file ?? []
        setFiles(file)
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getNewsTypeOption()
        getNewsWeightTypeOption()
    }
    const onFinish = (values) => {
        let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss")
        let announce_time_end = dayjs(values?.announce_time_end).format("YYYY-MM-DD HH:mm:ss")
        onFormFinish({
            ...values,
            news_time,
            announce_time_end
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }
    const onContentChange = (content) => {
        console.log({
            current:editor.current
        })
        setContent(content)
        if (propsForm) {
            propsForm.setFieldValue('news_content', content)
        }
        else {
            form.setFieldValue('news_content', content)
        }
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            console.log({minutes})
            if (todayDate === currentDate &&  currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes)+5) 
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });
    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
        onChangeFileValue(formValues)
        onContentChange(formValues?.news_content??"")
    }, [formReloadCount])

    return (
        <Row>

            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"news_id"}

                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"消息分類"}
                                name={"news_type_id"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Select
                                    popupMatchSelectWidth={false}
                                    options={newsTypeOption}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"重要程度"}
                                name={"news_weight_type_id"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Select
                                    popupMatchSelectWidth={false}
                                    options={newsWeightTypeOption}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"標題"}
                                name={"news_title"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>

                        
                        <Col span={24}>
                            <Form.Item
                                label={"發佈時間"}
                                name={"news_time"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    disabledDate={disabledDate}
                                    disabledTime={disabledDateTime}
                                    showTime={{
                                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                                    }}
                                    showNow={false}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"結束時間"}
                                name={"announce_time_end"}
                            >
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    disabledDate={disabledDate}
                                    disabledTime={disabledDateTime}
                                    showTime={{
                                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                                    }}
                                    showNow={false}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"內容"}
                                name={"news_content"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                                hidden={true}
                            >
                                <Input.TextArea>
                                </Input.TextArea>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <JoditEditor
                                ref={editor}
                                value={content}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={onContentChange} // preferred to use only this option to update the content for performance reasons
                                height={1000}
                                allowResizeX={true}
                                allowResizeY={true}
                            />
                        </Col>
                        <Col>
                            <Form.Item
                                name={"file"}
                                initialValue={[]}
                                hidden={true}
                            >
                                <Input
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={true}
                        >
                            <Form.Item
                                label={"圖片"}
                            >
                                <UploadImg
                                    defaultValue={files}
                                    onImagesChange={(files) => {
                                        propsForm.setFieldValue({
                                            file: files
                                        })
                                        setFiles(files)
                                    }}
                                />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </Col>
        </Row>


    )
}


export default NewsForm;
